import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { Tooltip } from "@mui/material";

export const CargoTankType = {
	"*": "*",
	"1": "Independent cargo tank",
	"2": "Integral cargo tank",
	"3": "Cargo tank with walls distinct from the outer hull",
	"4": "Membrane tank",
} as const;

export const ProductCargoTankTypeSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return <Select
		disableSearch
		fetchOptions={Object.keys(CargoTankType)}
		getOptionLabel={opt => getLabel(opt as keyof typeof CargoTankType)}
		multiple={false}
		value={value}
		onChange={onChange}
	/>;
};

function getLabel(cargoTankType: keyof typeof CargoTankType) {
	return cargoTankType === "*" ? "*" : `${cargoTankType}. ${CargoTankType[cargoTankType]}`;
}

// eslint-disable-next-line react-refresh/only-export-components
export function productCargoTankTypeField(cargoTankType: keyof typeof CargoTankType | undefined) {
	if (!cargoTankType) {
		return "-";
	}
	if (cargoTankType === "*") {
		return "*";
	}
	return <Tooltip title={CargoTankType[cargoTankType]} placement="right"><span>{cargoTankType}</span></Tooltip>;
}
